import { render, staticRenderFns } from "./BlackFriday.vue?vue&type=template&id=15c9dab0&scoped=true&"
import script from "./BlackFriday.vue?vue&type=script&lang=js&"
export * from "./BlackFriday.vue?vue&type=script&lang=js&"
import style0 from "./BlackFriday.vue?vue&type=style&index=0&id=15c9dab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9dab0",
  null
  
)

export default component.exports